<template>
    <br>
    <div id="service-multiple" class="one-service-area ptb-100">
        <div class="container">
            <div class="one-section-title">
                <span class="sub-title">{{ subTitle }}</span>
                <h2>{{ heading }}</h2>
            </div>

            <!-- Tabs centradas -->
            <nav class="tabs">
                <div class="tabs__header">
                    <a 
                        class="tabs__header-item" 
                        v-for="tab in tabs" 
                        v-on:click="selectTab(tab.id)" 
                        v-bind:class="{ 'active': activeTab == tab.id }"
                        :key="tab.id"
                    >
                        <div class="service-item">
                            <i :class="tab.icon"></i>
                            <span>{{ tab.name }}</span>
                        </div>
                    </a>
                </div>
            </nav>

            <!-- Contenedor de contenido centrado -->
            <div class="tabs__container tabs__container--center">
                <div 
                    class="tabs__list"
                    ref="tabsList"
                >
                    <div 
                        class="tabs__list-tab"
                        v-for="tab in tabs"
                        v-bind:class="{ 'active': activeTab == tab.id }"
                        :key="tab.id"
                    >
                        <div class="service-advisor">
                            <div class="row align-items-center">
                                <div class="col-lg-6">
                                    <div class="advisor-img">
                                        <img :src="tab.image" alt="Tintas">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="advisor-content">
                                        <h2>{{ tab.title }}</h2>
                                        <p>{{ tab.shortDesc }}</p>
                                        <ul>
                                            <li
                                                v-for="list in tab.lists"
                                                :key="list.id"
                                            >
                                                <i :class="list.icon"></i>
                                                {{ list.text }}
                                            </li>
                                        </ul>
                                        <div class="advisor-link">
                                            <a href="tel:+34 623 61 51 28">
                                                COMPRAR / PEDIR
                                            </a>
                                            <i class="bx bx-right-arrow-alt"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OurCoreService',
    props: ['subTitle', 'heading'],
    data () {
        return {
            activeTab: 1,
            offsetRight: 0,
            
            tabs: [
                {
                    id: 1,
                    icon: 'bx bx-droplet',
                    name: 'Tintas originales',
                    image: require('../../assets/img/resources/tintas-originales.png'),
                    title: 'Tintas originales del fabricante',
                    shortDesc: 'Suministro oficial de tinta para impresión digital de gran formato.',
                    lists: [
                        {
                            id: 1,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Colores precisos y consistentes según especificación del fabricante.',
                        },
                        {
                            id: 2,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Protege los cabezales y alarga la vida útil del equipo.',
                        },
                        {
                            id: 3,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Homologadas para tu modelo de impresora.',
                        },
                        {
                            id: 4,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Entrega rápida y trazable.',
                        },
                    ]
                },
                {
                    id: 2,
                    icon: 'bx bx-color-fill',
                    name: 'Tintas compatibles',
                    image: require('../../assets/img/resources/tintas-compatibles.png'),
                    title: 'Tintas compatibles de alta calidad',
                    shortDesc: 'Alternativa optimizada en coste manteniendo buen rendimiento.',
                    lists: [
                        {
                            id: 1,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Gran relación calidad / precio.',
                        },
                        {
                            id: 2,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Formulaciones estables: buena adhesión y resistencia.',
                        },
                        {
                            id: 3,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Compatibles con la mayoría de impresoras de gran formato.',
                        },
                        {
                            id: 4,
                            icon: 'bx bxs-chevrons-right',
                            text: 'Asesoramiento técnico para evitar errores de carga.',
                        },
                    ]
                }
            ]
        }
    },
    methods: {
        selectTab (id) {
            const tabsList = this.$refs.tabsList
            this.activeTab = id
            this.offsetRight = tabsList.clientWidth * (id - 1)
            tabsList.style.right = this.offsetRight + 'px'
        }
    }, 
    mounted () {
        const tabsList = this.$refs.tabsList
        tabsList.style.right = this.offsetRight + 'px'
    },
    computed: {
        products(){
            return this.$store.state.products.all.filter(item => {
                return item.productsType === 'left-sidebar'
            })
        }
    }
}
</script>

<style scoped>
/* ===============================
   Bloque de pestañas centradas
   =============================== */

/* Contenedor de tabs centrado y con columnas iguales */
.tabs__header {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 280px)); /* botones iguales */
  gap: 1rem;
  justify-content: center;    /* 🔹 centra el grupo de botones */
  align-items: center;
  margin: 0 auto 2rem;        /* centrado + espacio inferior */
  width: 100%;
}

/* Cada enlace ocupa toda su celda */
.tabs__header-item {
  display: block;
  text-decoration: none;
  width: 100%;
}

/* Botón */
.service-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 16px 18px;
  border-radius: 10px;
  transition: all 0.3s ease;
}

/* Estado activo */
.tabs__header-item.active .service-item {
  background: var(--main-color, #d35400);
  color: #fff;
}

/* Estado inactivo */
.tabs__header-item:not(.active) .service-item {
  background: #f4f4f4;
  color: #333;
}

/* Hover */
.tabs__header-item:hover .service-item {
  opacity: 0.9;
}

/* Responsive: en móviles apila verticalmente */
@media (max-width: 600px) {
  .tabs__header {
    grid-template-columns: 1fr;
    max-width: 360px;
    justify-content: center;
  }
}

/* ===============================
   Contenido del bloque general
   =============================== */

.tabs__container--center {
  max-width: 1100px;
  margin: 0 auto;
}

.one-section-title {
  text-align: center;
}

.one-section-title h2 {
  margin-bottom: 2rem;
}

/* Estilo del enlace dentro de cada pestaña */
.advisor-link a {
  color: var(--main-color, #d35400);
  font-weight: bold;
  text-decoration: none;
}
/* ====== Fix centrado y ancho ESTABLE SOLO en tablet (768–1199px) ====== */
@media (min-width: 768px) and (max-width: 1199px) {
  /* Centra el contenedor de tabs dentro del .container */
  .tabs {
    display: flex;
    justify-content: center;
  }

  /* 2 columnas fijas y centradas, sin permitir encogimiento */
  .tabs__header {
    display: grid;
    grid-template-columns: repeat(2, 280px);   /* ancho fijo por botón */
    gap: 1rem;
    justify-content: center;                   /* centra el grupo */
    margin-left: auto;
    margin-right: auto;
    max-width: calc(560px + 1rem);             /* 2×280 + gap */
  }

  /* Evita que el contenido se “aplane” en puntos intermedios */
  .tabs__header-item,
  .tabs__header-item .service-item {
    min-width: 280px;      /* coincide con la columna */
    flex: 0 0 auto;        /* no encoge en ningún caso */
  }
}


</style>
